import { useTranslations } from "use-intl";
import { ClockCounterClockwiseIcon } from "@phosphor-icons/react";

import { usePreviousAirportSearches } from "@/app/lib/hooks/usePreviousSearches";
import type { FlightFormLocation } from "@/app/lib/types/types";
import { SearchResultList, SearchResultButton } from "./SearchResultList";

type Props = {
  previousSearches: FlightFormLocation[];
  onClick: (location: FlightFormLocation) => void;
};

export function LastSearchedAirportList({ onClick, previousSearches }: Props) {
  const t = useTranslations();
  const { removePreviousSearch } = usePreviousAirportSearches();

  return (
    <SearchResultList
      heading={t("flights.search.lastSearched")}
      data={previousSearches}
      getItemKey={(location) => location.id}
      renderItem={(location) => {
        return (
          <SearchResultButton
            key={location.id}
            icon={ClockCounterClockwiseIcon}
            primaryText={location.name}
            code={location.code}
            onClick={() => onClick(location)}
            onRemove={() => removePreviousSearch(location.id)}
            {...(location.type === "AIRPORT"
              ? {
                  secondaryText: `${location.cityName}, ${location.countryName}`,
                }
              : { secondaryText: location.countryName })}
          />
        );
      }}
    />
  );
}
